import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class SystemConfigService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  getAllSystemConfigService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.systemConfigServicesURLs.getSystemConfigs,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editSystemConfigService = async (session_id, config) => {
    try {
      return await this.HttpService.putJson(
        this.constants.systemConfigServicesURLs.editSystemConfigs,
        {
          key: config.key,
          value: config.value,
          configCategory: config.configCategory,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editLoggingLevel = async (session_id, value) => {
    try {
      return await this.HttpService.postJson(
        this.constants.actuatorURLs.editLoggingFile,
        {
          configuredLevel: value,
          effectiveLevel: value,
          // configCategory: config.configCategory
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  addSystemConfigService = async (session_id, config) => {
    try {
      return await this.HttpService.postJson(
        this.constants.systemConfigServicesURLs.postSystemConfigs,
        {
          key: config.key,
          value: config.value,
          configCategory: config.configCategory,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
